import axios, { AxiosError, AxiosResponse } from "axios";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { rateAgreementUrls } from "../../../URL/ApplicationUrls";
import { RateAgreement } from "../RateAgreement";
import { addSuccessMessage } from "../../../Messages/successMessages";
import { MdmApiError } from "../../../Errors/MdmApiError";
import { apiErrorNotificationToast } from "../../../Errors/apiErrorNotificationToast";

export const useAddRateAgreement = () => {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: (rateAgreement: RateAgreement) => {
      return axios.post<number>(rateAgreementUrls.base.apiUrl, rateAgreement);
    },
    onSuccess: async (response: AxiosResponse) => {
      navigate(rateAgreementUrls.uiPathForRateAgreementWithId(response.data));
      toast.success(addSuccessMessage(response.data, "Rate Agreement"));
    },
    onError: (error: AxiosError<MdmApiError>) => {
      apiErrorNotificationToast(error);
    },
  });
};
